import React from 'react';
import navLogo from '../images/netflix1.png';
import { BsFillCaretRightFill, BsFillCaretDownFill } from "react-icons/bs";

function Navbar() {
    return (
        <div className='main'>
        <nav>
            <a href='/' className='nav-logo'>
                <img src={navLogo} alt="nav_logo"/>
            </a>
            <input className='menu-btn' type='checkbox' id='menu-btn'/>
            <label className='menu-icon' for='menu-btn'>
                <span className='nav-icon'></span>
            </label>

            <ul className='menu'>
                <li><a href='home' className="active">Home</a></li>
                <li><a href='#page__search' target="_blank"><div className='icons'><BsFillCaretRightFill/></div>Movies</a></li>
                <li><a href='#page__search' target="_blank"><div className='icons'><BsFillCaretRightFill/></div>Series</a></li>
                <li><a href='https://www.netflix.com/in/login' target="_blank"><div className='icons'><BsFillCaretRightFill/></div>Login</a></li>
                <li><a href='https://www.netflix.com/in/login?nextpage=https%3A%2F%2Fwww.netflix.com%2Fyouraccount' target="_blank"><div className='icons'><BsFillCaretRightFill/></div>Account Settings</a></li>
            </ul>
        </nav>
        </div>
    );
}

export default Navbar;
